export enum BuildingStatusEnum {
  /** @deprecated The Upcoming status is deprecated. All Upcoming entries have been migrated to Available status. */
  Upcoming = 'Upcoming',
  Available = 'Available',
  Reserved = 'Reserved',
  Full = 'Full',
  Rental = 'Rental',
}

// Mapper les valeurs numériques vers les valeurs string de l'enum
export const getBuildingStatusString = (status: any): string => {
  if (typeof status === 'string') {
    return status;
  }
  
  // Map des valeurs numériques vers les strings correspondants
  const statusMap: { [key: number]: string } = {
    0: 'Upcoming', // Obsolète - migré vers Available
    1: 'Available',
    2: 'Reserved',
    3: 'Full',
    4: 'Rental'
  };
  
  return statusMap[status] || 'Available';
};
